import { FC, ReactNode } from "react";
import { useToggle } from "rooks";
import { Box, Collapse, IconButton, Stack } from "@mui/material";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { useHover } from "../../../../../../../../../utils/hooks/useHover.hook";

interface AutomationResourceFiltersExpandWrapperProps {
  title: ReactNode;
  children: ReactNode;
}

export const AutomationResourceFiltersExpandWrapper: FC<
  AutomationResourceFiltersExpandWrapperProps
> = ({ children, title }) => {
  const { ref, hovered } = useHover();
  const [collapsed, toggleCollapsed] = useToggle(false);

  return (
    <Stack
      my={1}
      border={1}
      px={0.5}
      py={0.25}
      borderColor={hovered ? "grey.600" : "grey.400"}
      borderRadius={1}
    >
      <Stack ref={ref} direction="row" alignItems="center" spacing={0.5}>
        <IconButton size="small" onClick={toggleCollapsed}>
          {collapsed ? (
            <KeyboardArrowDownIcon fontSize="small" />
          ) : (
            <KeyboardArrowRightIcon fontSize="small" />
          )}
        </IconButton>

        {title}
      </Stack>
      <Collapse in={collapsed}>
        <Box p={1} pl={4}>
          {children}
        </Box>
      </Collapse>
    </Stack>
  );
};
